import React, { useState, useEffect } from 'react';
import leftArrowVector from "../../../Asset/left-arrow-vector-carousel.svg";
import rightArrowVector from "../../../Asset/right-arrow-vector-carousel.svg";
import Axios from 'axios';
import UltimatePickleballImage from "../../../Asset/StayInTouchCard/PickleBallMixer2.jpg"
import WomensFootballLeague from "../../../Asset/Carousel/womens-football-league.jpg";
import SundayPadelLeague from "../../../Asset/Carousel/sunday-padel-league.jpg";
import PickleballXArks from "../../../Asset/Carousel/pickleball-x-arks.jpg";
import PickleballMatchPoint from "../../../Asset/Carousel/pickleball-match-point.jpg";
import MixedFootballShowdown from "../../../Asset/Carousel/mixed-football-showdown.jpg";
import MensFootballShowdown from "../../../Asset/Carousel/mens-football-showdown.jpg";
import TournamentBadge from "../../../Asset/Badges/Tournament-Badge.svg";
import LeagueBadge from "../../../Asset/Badges/League-Badge.svg";
import SocialBadge from "../../../Asset/Badges/Social-Badge.svg";
import BootcampBadge from "../../../Asset/Badges/Bootcamp-Badge.svg";


const StayInTouchCarousel = () => {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [eventImages, setEventImages] = useState([
        {
            eventId: "womens-football",
            eventType: "Tournament",
            imageUrl: WomensFootballLeague,
            title: "Women's Football League"
        },
        {
            eventId: "sunday-padel",
            eventType: "League",
            imageUrl: SundayPadelLeague,
            title: "Sunday Padel League"
        },
        {
            eventId: "pickleball-x-arks",
            eventType: "Social",
            imageUrl: PickleballXArks,
            title: "Singles Pickle Mixer x ARKS"
        },
        {
            eventId: "pickleball-match-point",
            eventType: "Tournament",
            imageUrl: PickleballMatchPoint,
            title: "Pickleball Match Point"
        },
        {
            eventId: "mixed-football",
            eventType: "Tournament",
            imageUrl: MixedFootballShowdown,
            title: "Mixed Football Showdown"
        },
        {
            eventId: "mens-football",
            eventType: "Tournament",
            imageUrl: MensFootballShowdown,
            title: "Men's Football Showdown"
        }
    ]);
    const [currentIndex, setCurrentIndex] = useState(0); // Track the current index
    function getTodayDate() {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0'); // 0-indexed months
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    console.log('event imgs ', eventImages)
    useEffect(() => {
        const fetchData = async () => {


            const todayDate = getTodayDate()
            console.log(todayDate);

            try {
                const res = await Axios.get(`${process.env.REACT_APP_BASE_URL}/events/?event_time_lt=${todayDate}&limit=5&offset=0`);
                console.log('this is res', res.data.events)
                setEvents(res.data.events);
                setLoading(false);
            } catch (error) {
                setError(error.message);
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    useEffect(() => {
        const fetchImages = async () => {
            if (events.length === 0) return; // Don't run if no events yet

            const imagePromises = events.map(async (event) => {
                // Get the image with tag 'WIDE'
                const wideImage = event.EventImages.find(img => img.Tags.includes('WIDE'));

                if (wideImage) {
                    try {
                        const res = await Axios.get(
                            `${process.env.REACT_APP_BASE_URL}/files/${wideImage.FileId}/download`,
                            { responseType: "blob" }
                        );
                        const imageURL = URL.createObjectURL(res.data);
                        return {
                            eventId: wideImage.FileId,
                            imageUrl: imageURL,
                            title: event.EventTitle,
                            eventType: event.EventType
                        };
                    } catch (error) {
                        console.error("Error fetching image for event", wideImage.FileId, error);
                        return {
                            eventId: wideImage.FileId,
                            imageUrl: "",
                            title: event.EventTitle,
                            eventType: event.EventType
                        };
                    }
                } else {
                    console.warn("No WIDE image found for event:", event.EventTitle);
                    return {
                        eventId: null,
                        imageUrl: "",
                        title: event.EventTitle,
                        eventType: event.EventType
                    };
                }
            });

            const images = await Promise.all(imagePromises);
            setEventImages(prev => [...prev, ...images]);
        };

        fetchImages();
    }, [events]);



    // Move carousel with looping
    const moveCarousel = (direction) => {
        if (direction === 'left') {
            setCurrentIndex((prevIndex) =>
                prevIndex === 0 ? eventImages.length - 1 : prevIndex - 1
            );
        } else {
            setCurrentIndex((prevIndex) =>
                prevIndex === eventImages.length - 1 ? 0 : prevIndex + 1
            );
        }
    };

    const getBadge = (type) => {
        if (!type) return null;
        const lowerType = type.toLowerCase();
        if (lowerType.includes('tournament')) return TournamentBadge;
        if (lowerType.includes('league')) return LeagueBadge;
        if (lowerType.includes('social')) return SocialBadge;
        if (lowerType.includes('bootcamp')) return BootcampBadge;
        return null;
    };

    // if (loading) return <p>Loading...</p>;
    // if (error) return <p>Error: {error}</p>;

    return (
        <div className="flex justify-center items-center relative w-full group">
            <button
                className="absolute top-1/2 md:-left-8 -left-4 transform -translate-y-1/2 text-white rounded-full z-40 transition-transform active:scale-95"
                onClick={() => moveCarousel('left')}
            >
                <img className='w-[2.5rem] md:w-16 drop-shadow-md' src={leftArrowVector} alt="left arrow" />
            </button>

            <div className='w-full overflow-hidden rounded-[2.0rem] md:rounded-[3.0rem] shadow-xl bg-[var(--medium-purple)]'>
                <div
                    className="flex transition-transform ease-in-out duration-500"
                    style={{ transform: `translateX(-${currentIndex * 100}%)` }}
                >
                    {eventImages.map((image, index) => (
                        <div key={`${image.eventId}-${index}`} className="flex-shrink-0 w-full relative flex flex-col">
                            {/* Image Section */}
                            <div className="relative w-full aspect-[4/3] md:aspect-[1.6/1] overflow-hidden">
                                <img
                                    src={image.imageUrl}
                                    className="w-full h-full object-cover"
                                    alt={image.title}
                                />

                                {/* Section Label Overlay */}
                                <div className="absolute top-4 left-6 md:top-4 md:left-6 z-30">
                                    <p className="font-ClashGrotesk font-medium text-xs md:text-xl text-white drop-shadow-lg opacity-90">
                                        Recent Net Gala Events
                                    </p>
                                </div>

                                {/* Badge Overlay */}
                                {getBadge(image.eventType) && (
                                    <div className="absolute bottom-[-15%] right-2 md:right-8 z-30 transform translate-y-[-10%] md:translate-y-0">
                                        <img
                                            src={getBadge(image.eventType)}
                                            alt={image.eventType}
                                            className="w-[6rem] md:w-[11rem] drop-shadow-xl"
                                        />
                                    </div>
                                )}
                            </div>

                            {/* Title Section */}
                            <div className="bg-[var(--medium-purple)] px-6 py-8 md:px-6 md:py-6">
                                <h3 className="font-manrope text-xl md:text-[2.2rem] font-[700] text-white leading-tight">
                                    {image.title}
                                </h3>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <button
                className="absolute top-1/2 md:-right-8 -right-4 transform -translate-y-1/2 text-white rounded-full z-40 transition-transform active:scale-95"
                onClick={() => moveCarousel('right')}
            >
                <img className='w-[2.5rem] md:w-16 drop-shadow-md' src={rightArrowVector} alt="right arrow" />
            </button>
        </div>
    );
};

export default StayInTouchCarousel;
